import { useRef } from 'react'
import { useDrop } from 'react-dnd'
import { useDataValue } from 'Simple/Data.js'
import View from './view.js'
import { useOnMoveBoard } from '../../Content/helpers.js'

let ITEM_TYPE = 'BOARD_ITEM'

function EmptyDropZone({ list_type, onMove, ...props }) {
  let ref = useRef(null)

  let [{ isActive }, drop] = useDrop({
    accept: ITEM_TYPE,
    collect: monitor => ({
      isActive: monitor.canDrop() && monitor.isOver(),
    }),
    drop(draggedItem) {
      // Cross-list move into empty list
      if (draggedItem.list_type !== list_type) {
        if (typeof onMove === 'function') {
          onMove(
            draggedItem.board_id,
            draggedItem.list_type,
            list_type,
            0,
            draggedItem.sourceBoards || [],
            []
          )
        }
      }
    },
  })

  drop(ref)

  return <View {...props} innerRef={ref} isActive={isActive} />
}

export default function Logic(props) {
  let list_type = useDataValue({
    context: 'task_boards_list',
    path: 'type',
    viewPath: props.viewPath,
  })

  let onMove = useOnMoveBoard(props)

  // Skip drag-drop for private boards
  if (list_type === 'private') {
    return <View {...props} />
  }

  return <EmptyDropZone {...props} list_type={list_type} onMove={onMove} />
}
